module.exports = __webpack_public_path__ + "static/media/9.e3a08a14.jpg";